export enum ProductExpandDetailsContentType {
  Information = 'Information',
  SimilarProducts = 'SimilarProducts',
}
